import { forwardRef, type Ref, type SVGProps } from "react";
const IconSortAscendingOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m14.308 10.812-.002-.001a1.07 1.07 0 0 1 0-1.499l6.896-7.002c.215-.204.502-.316.798-.31.297-.012.587.1.798.31l6.896 7.002a1.07 1.07 0 0 1 0 1.499l-.002.001a1.035 1.035 0 0 1-1.478 0l-5.228-5.313V29a.987.987 0 1 1-1.973 0V5.499l-5.227 5.313a1.036 1.036 0 0 1-1.479 0M3 11h4a1 1 0 1 0 0-2H3a1 1 0 0 0 0 2m0 6a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zm14 6H3a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSortAscendingOutlineSVG);
ForwardRef.displayName = "IconSortAscendingOutline";
export { ForwardRef as IconSortAscendingOutline };
